"use client";

import type { ReactNode } from "react";

// SIP/Softphone in preview mode — not yet available
export function SipShell({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
